import { render, staticRenderFns } from "./Licensing.vue?vue&type=template&id=1d6db70a&scoped=true&lang=pug"
import script from "./Licensing.vue?vue&type=script&lang=js"
export * from "./Licensing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6db70a",
  null
  
)

export default component.exports